import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithShippingPolicyHealthProvider, useShippingPolicyHealth] = createComponentHealth('ShippingPolicy');
